import React, { useEffect, useState } from 'react'
import moment, { Moment } from 'moment'
import { utils, write } from 'xlsx'
import { saveAs } from 'file-saver'

const localStorageBreadcrumbsKey = 'breadcrumbs'

export const sortArray = (array) => {
    return array.sort((a, b) => {
        return a.id - b.id
    })
}

export const formatDate = (date: string | number, format?: string) => {
    const newDate = new Date(date)
    return moment(moment.utc(newDate).format()).format(format ? format : 'DD/MM/YYYY HH:mm')
}

export const formatDateRequest = (date: string) => {
    const newDate = new Date(date)
    const formatDate = moment(moment.utc(newDate).format()).format('YYYY-MM-DD')
    return formatDate + 'T00:00:00.000Z'
}

export const findGetParameter = (parameterName) => {
    var result = null,
        tmp = []
    var items = location.search.substr(1).split('&')
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
    }
    return result
}

export const formatDateLocale = (date: string) => {
    const locale = window?.navigator?.language
    // moment.locale(locale)
    const localeData = moment.localeData()
    const format = localeData.longDateFormat('L')
    const dateMomentObj = moment(date, 'DD/MM/YYYY')
    const dateObj = dateMomentObj.toDate()
    const dateObjToStr = dateObj.toString()
    return moment(dateObjToStr).format(format)
}

export const formatDateHourLocale = (date: string) => {
    const localeData = moment.localeData()
    const format = localeData.longDateFormat('LT')
    return moment(date).format(format)
}

export const changeBreadcrumbs = (title?: string) => {
    let breadcrumbs = document.getElementsByClassName('wardrobe-breadcrumb')[0]
        .firstChild as HTMLElement
    let breadcrumbsLast = breadcrumbs.lastChild.firstChild.firstChild as HTMLElement
    breadcrumbsLast.innerText = title ? title : '-'
}

export const getQuery = (obj: any): string => {
    let haveAlreadyParams: boolean = false
    let query: string = ''
    if (obj) {
        query += '?'
        Object.keys(obj).map((key) => {
            const value: any = obj[key]
            if (value !== null && value !== undefined && value.toString().length > 0) {
                if (haveAlreadyParams) {
                    query += '&'
                }
                query += key + '=' + JSON.stringify(value)
                haveAlreadyParams = true
            }
        })
        if (!haveAlreadyParams) {
            return ''
        }
    }
    return query
}

export const s2ab = (s: any) => {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
}

export const getDifferences = (array1: any[], array2: any[], field: string) => {
    return array1.filter((object1) => {
        return !array2.some((object2) => {
            return object1[field] === object2[field]
        })
    })
}

export const isMobileChecker = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsMobile(true)
            } else {
                setIsMobile(false)
            }
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return isMobile
}

export const getRemainingDays = (startDate: Moment, endDate: Moment): number => {
    return endDate.diff(startDate, 'days')
}

export const downloadExcelFromList = (listData: any[], filename: string) => {
    const worksheet = utils.json_to_sheet(listData)
    const workbook = utils.book_new()
    utils.book_append_sheet(workbook, worksheet, 'Sheet1')
    const wbout = write(workbook, { bookType: 'xlsx', type: 'array' })
    var blob = new Blob([new Uint8Array(wbout)], { type: 'application/octet-stream' })
    const fileName = `${filename}.xlsx`
    if ((window as any).webkit) {
        var a = new FileReader()
        a.onload = (e) => {
            ;(window as any).webkit.messageHandlers.downloadFromUrl.postMessage({
                url: e.target.result,
                filename: fileName,
            })
        }
        a.readAsDataURL(blob)
    } else {
        saveAs(blob, fileName)
    }
}

export const downloadPhoto = (url: string, name: string) => {
    try {
        ;(window as any).webkit.messageHandlers.downloadFromUrl.postMessage({
            url,
            filename: name,
        })
    } catch (error) {
        fetch(url)
            .then((res) => res.blob())
            .then((res: any) => {
                saveAs(new Blob([res]), name)
            })
    }
}

export const getBreadcrumbs = () => {
    const localStorageBreadcrumbs = localStorage.getItem(localStorageBreadcrumbsKey)
    // Rimuove il protocollo e divide l'URL in parti
    let breadcrumbs = [];
    if (localStorageBreadcrumbs) {
        let parts = localStorageBreadcrumbs.replace(/(^\w+:|^)\/\//, '').split('/');

        for (let i = 1; i < parts.length; i++) {
            let breadcrumb = parts.slice(0, i + 1).join('/');
            breadcrumbs.push({
                name: parts[i].split('?')[0] !== '' ? parts[i].split('?')[0] : 'home',
                url: 'https://' + breadcrumb
            });
        }
    }
    return breadcrumbs;
}
